// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;The Lord sits enthroned above the water flood;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord sits enthroned as king for evermore.<br> </p> </div></div>";
// Exports
module.exports = code;